import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=a1c0be60&"
import script from "./InvoiceList.vue?vue&type=script&lang=js&"
export * from "./InvoiceList.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports